import * as React from "react";

function Input({ className, type, ...props }: React.ComponentProps<"input">) {
  return (
    <input
      type={type}
      data-slot="input"
      className={`file:text-foreground text-body-normal/md text-text-900 placeholder:text-text-600 placeholder:text-body-normal/md border-input flex h-9 w-full min-w-0 rounded-md border bg-transparent px-3.5 py-[15.5] transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive focus:outline-none focus:ring-0 ${className || ''}`}
      {...props}
    />
  );
}

export { Input };
